import '@stigg/react-sdk/dist/styles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Paywall, StiggProvider, StiggProviderProps } from '@stigg/react-sdk';
import { name as CLIENT_NAME, version as CLIENT_VERSION } from '../package.json';

let sharedConfig = {
  apiKey: undefined,
  baseUri: undefined,
  customerId: undefined,
  theme: undefined,
  locale: undefined,
};

/**
 * @param {StiggProviderProps} config
 */
const Stigg = (config) => {
  if (!config.apiKey) {
    throw new Error('Cannot initialize Stigg, apiKey is missing');
  }

  sharedConfig = {
    clientName: CLIENT_NAME,
    clientVersion: CLIENT_VERSION,
    ...config,
  };
  return {
    /**
     * @param {PaywallProps} paywallConfig
     */
    Paywall: (paywallConfig) => {
      return {
        mount: (selector) => {
          ReactDOM.render(
            <StiggProvider {...sharedConfig}>
              <Paywall {...paywallConfig} />
            </StiggProvider>,
            document.querySelector(selector),
          );

          return () => {
            ReactDOM.unmountComponentAtNode(document.querySelector(selector));
          };
        },
      };
    },
  };
};

export default Stigg;
